<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h5 class="text-center">{{ titleCard }}</h5>
          <VChart
            class="chart"
            :option="plotChart()"
            :autoresize="true"
            v-if="surveys"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  LegendComponent,
} from 'echarts/components'
import VChart from 'vue-echarts'

use([
  CanvasRenderer,
  GridComponent,
  PieChart,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
])

export default {
  name: 'ChartDistribution',

  props: {
    surveys: {
      type: Object,
      required: true,
    },
  },

  components: {
    VChart,
  },

  data() {
    return {
      titleCard: 'Desempenho',
    }
  },

  methods: {
    plotChart() {
      const dataSeries = [
        { value: this.surveys.totalNotAccess, name: 'Não Acessados' },
        { value: this.surveys.totalViewed, name: 'Visualizados sem Resposta' },
        {
          value: this.surveys.totalPartiallyAnswered,
          name: 'Respondidos Parcialmente',
        },
        { value: this.surveys.totalAnswered, name: 'Respondidos' },
      ]

      const optionReder = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          show: false,
          left: 'center',
          data: [
            'Não Acessados',
            'Visualizados sem Resposta',
            'Respondidos Parcialmente',
            'Respondidos',
          ],
        },
        series: [
          {
            name: this.titleCard,
            type: 'pie',
            radius: ['50%', '90%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: dataSeries,
          },
        ],
      }
      return optionReder
    },
  },
}
</script>

<style scoped>
.chart {
  height: 150px;
}
</style>
